<template>
  <div class="col-12 list-container nopads">
    <div v-if="resultList && resultList.length > 0" class="col-sm-12 list-content result-table">
        <vue3-datatable
            ref="resultTable"
            :rows="resultList"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            :height="resultList.length > 8 ? '50vh' : '100%'"
            :sortable="true"
            skin="bh-table-compact"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
            @row-click="emitEdit"
        >
            <template #start_time="row">
                {{ row.value.start_time ? toLocalTime(row.value.start_time) : '' }}
            </template>
            <template #time="row">
                {{ row.value.time ? toLocalTime(row.value.time) : '' }}
            </template>
            <template #total_time="row">
                {{ displayWorkTime(row.value) }}
            </template>
            <template #addition="row">
                {{ row.value.added_by ? $t('areas.manual_addition') : $t('areas.tracking') }}
            </template>
            <template #cost="row">
                {{ row.value.cost && row.value.cost > 0 ? (row.value.cost/100).toFixed(2) : '' }}
            </template>
        </vue3-datatable>
    </div>
  </div>
</template>

<script>
import {timeUtils} from "../../mixins/TimeUtils";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'AreaWorkList',
    components: {Vue3Datatable},
    mixins: [timeUtils],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        },
        showAdd: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            sortBy: 'created',
            sortDesc: true,
            sortDirection: 'asc',
            resultList: [],
            fields: [
                {field: 'start_time', title: this.$t('areas.started'), sort: true, headerClass: 'routa-table-header'},
                {field: 'time', title: this.$t('areas.time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'total_time', title: this.$t('work_time.work_time') + ' (H:mm)', sort: true, headerClass: 'routa-table-header'},
                {field: 'area_name', title: this.$t('areas.area'), sort: true, headerClass: 'routa-table-header'},
                {field: 'area_square_meters', title: this.$t('areas.square_meters'), sort: true, headerClass: 'routa-table-header'},
                {field: 'task_type_name', title: this.$t('areas.work_task'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract.name', title: this.$t('areas.work_contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'addition', title: this.$t('areas.addition'), sort: true, headerClass: 'routa-table-header'},
                {field: 'cost', title: this.$t('daily_summary.cost', {currency: import.meta.env.VITE_APP_CURRENCY}), sort: true, headerClass: 'routa-table-header'}
            ],
        }
    },
    watch: {
        results() {
            this.resultList = []
            let temp = []
            this.results.forEach(item => {
                temp.push(item)
            })
            this.$nextTick(() => {
                this.resultList = temp
            })
        }
    },
    mounted: function () {
        this.resultList = this.results
    },
    methods: {
        emitEdit: function (result) {
            // Find defect item from original items and emit request to edit
            let p = this.results.find(item => item.id === result.id)
            if (p) {
                this.$emit('edit', p)
            }
        },
        displayWorkTime(row) {
            if (!row || !row.time || !row.start_time) return '';
            const minutes = this.getMins(row);
            return minutes > 0 ? this.getWorkTime(minutes) : '';
        },

        getMins(item) {
            if (item.start_time && item.time) {
                let start = new Date(item.start_time)
                let end = new Date(item.time)
                return (end.getTime() - start.getTime()) / (1000 * 60)
            }
            return 0
        }
    }
}
</script>

<style scoped>
</style>
